import { isAxiosError } from 'axios';

export class GlobalErrorHandler {
  static hashObject(obj: unknown): string {
    const str = JSON.stringify(obj);
    return Array.from(str)
      .reduce((hash, char) => (hash << 5) - hash + char.charCodeAt(0), 0)
      .toString();
  }

  static addToSessionStorage(key: string, value: string) {
    sessionStorage.setItem(key, value);
    setTimeout(() => sessionStorage.removeItem(key), 5000);
  }

  static checkIsThrown(key: string, hash: string) {
    const previousHash = sessionStorage.getItem(key);
    return hash === previousHash;
  }

  static getErrorMessage<T extends Error = Error>(error: T) {
    const simpleError = error.message ?? 'Something went wrong';
    if (!isAxiosError(error)) return simpleError;

    const data = error.response?.data;
    if (!data) return simpleError;

    if (typeof data === 'string' && data.trim() !== '') return simpleError;

    if (typeof data !== 'object') return simpleError;

    if (!('errors' in data)) return simpleError;

    const errors = data.errors;

    if (typeof errors === 'string' && errors.trim() !== '') return errors;

    if (Array.isArray(errors)) {
      const mergedMsgs = errors.join(', ').trim();
      return mergedMsgs !== '' ? mergedMsgs : simpleError;
    }

    if (typeof errors === 'object') {
      const mergedMsgs = Object.values(errors ?? {})
        .flat()
        .join(', ')
        .trim();

      return mergedMsgs !== '' ? mergedMsgs : simpleError;
    }

    return simpleError;
  }
}
